<template>

    <Row class="service-group">
        <navbar :transparent="isTransparent" activeTo="Services"></navbar>
        <i-col :span="24">
            <section class="banner">
                <div class="services-bg">
                    <div class="services-page">
                        <h1 class="banner-title-sport">{{$t('Services_banner_title')}}</h1>
                        <p class="banner-content">{{$t('Services_banner_title_tips')}}</p>
                    </div>
                </div>
            </section>
            <div class="service-main" id="service-main">
                <div class="service-main-2 max_width">
                    <div class="services-title">
                        <p>{{$t('footer_FAQ')}}</p>
                    </div>
                    <Row>
                        <i-col :xs="24" :sm="24" :md="10" :lg="7">
                            <div class="services-list">
                                <div class="services-slider">
                                    <div class="Product-search">
                                        <input class="Product-search-input" width="24" v-on:focus="insinte()"  @blur.prevent="blurFn" v-model="searchWord" @keyup.enter="searchFaq" :placeholder="$t('enter_keyword')">
                                        <img class="Product-search-icon" src="../../assets/search_icon.png" width="24" @click="searchFaq">
                                        <div class="service-type-group" v-if="history">
                                            <div class="service-type-content" v-if="null_data">
                                                <li>{{$t('faq_norecord')}}</li>
                                            </div>
                                            <div class="service-type-content" v-else>
                                                <li v-for="(item,index) in like_list" :key="index" @click="keyword_search(item)">
                                                    {{item}}
                                                </li>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="services-slider-2 pc-problem-list">
                                    <ol class="pc-search">
                                        <li class="question-type" v-for="(item,index) in tabs" :key="index" style="text-align: center;" @click="toggle($event,index)">
                                            <router-link :to="{name:'problemList',query:{category_id:item.category_id,id:item.id}}">
                                                <div class="question-type-wrap" :class="{active:index == num}">
                                                    <span class="question-type-img">
                                                        <img :src="item.selecte_icon" width="35" style="margin-top: -4px;" v-if="index == num">
                                                        <img :src="item.normal_icon" width="35" style="margin-top: -4px;" v-else>
                                                    </span>
                                                        <a>{{item.name}}</a>
                                                    <span class="question-type-right"  v-if="kind_icon == index">
                                                        <Icon type="chevron-down"></Icon>
                                                    </span>

                                                    <span class="question-type-bottom"  v-else>
                                                        <Icon type="chevron-right"></Icon>
                                                    </span>
                                                </div>
                                            </router-link>
                                            <div class="question-type-content" v-show="kind_this" v-if="kind_title == index">
                                                <ol>
                                                        <li v-for="(item,index) in item.type_list" :key="index">
                                                            <router-link :to="{name:'problemList',query:{category_id:item.category_id,id:item.id}}">
                                                                <a>{{item.name}}</a>
                                                            </router-link>
                                                        </li>

                                                </ol>
                                            </div>
                                        </li>
                                    </ol>
                                    <ol class="mb-search">
                                        <li class="question-type" v-for="(item,index) in tabs" :key="index" style="text-align: center;" @click="toggle($event,index)">
                                            <router-link :to="{name:'problemSearch',query:{category_id:item.category_id,id:item.id}}">
                                                <div class="question-type-wrap">
                                                    <span class="question-type-img">
                                                        <Icon type="android-cart"></Icon>
                                                    </span>
                                                    <a>{{item.name}}</a>
                                                    <span class="question-type-right"  v-if="kind_icon == index">
                                                        <Icon type="chevron-down"></Icon>
                                                    </span>

                                                    <span class="question-type-bottom"  v-else>
                                                        <Icon type="chevron-right"></Icon>
                                                    </span>
                                                </div>
                                            </router-link>
                                            <div class="question-type-content" v-show="kind_this" v-if="kind_title == index">
                                                <ol>
                                                    <li v-for="(item,index) in item.type_list" :key="index">
                                                        <router-link :to="{name:'problemList',query:{category_id:item.category_id,id:item.id}}">
                                                            <a>{{item.name}}</a>
                                                        </router-link>
                                                    </li>

                                                </ol>
                                            </div>
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </i-col>

                        <i-col :xs="24" :sm="24" :md="14" :lg="17">
                            <div class="service-answer">
                                <div style="text-align:left;margin:0 0 8% 0;">
                                    <router-view></router-view>
                                </div>
                            </div>
                        </i-col>
                    </Row>
                </div>
            </div>
            <BackTop>
                <div class="top">
                    <img src="../../assets/backtop/top.png">
                    <p style="">TOP</p>
                </div>
            </BackTop>
            <a href="http://ifree.ly/support" target="_blank">
                <BackTop :height="100" :bottom="110">
                    <div class="top">
                        <img src="../../assets/backtop/service.png">
                        <p>Service</p>
                    </div>
                </BackTop>
            </a>
        </i-col>
    </Row>
</template>
<script>
    import navbar from '../Common/Navbar.vue'
    import mogo from './tabs/services_mogo.vue'
    import mogos from './tabs/services_mogos.vue'
    import igo from './tabs/services_igo.vue'
    import ProblemList from './ProblemList.vue'
    import Signature from '../../lib/Signature'

    export default {
        data () {
            return {
                tabs: [],
                isTransparent: true,
                flag: 0,
                searchWord: '',
                history:false,
                like_list:[],
                null_data:true,
                kind_title:3,
                kind_this:false,
                kind_icon:-1,
                num:-1

            }
        },
        components: {
            mogo, mogos, igo, navbar, ProblemList
        },
        methods: {
            toggle:function(e,i){
                this.num = i
                if (i == 3) {
                    this.kind_this = true
                    this.kind_title = i
                    this.kind_icon = i
                }else{
                    this.kind_icon = -1
                    this.kind_this = false
                }
            },
            getFaqtType: function () {
                //获取分类
                const module = 'index.php/faq/category'
                let data = {}
                data.user_id = this.Local.getUserId()
                data.lang = this.$i18n.locale
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                this.$http.get(process.env.BASEURL + module, {params: data})
                    .then(function (response) {
                        console.log(response.data)
                        this.tabs = response.data.data
                    }.bind(this))
            },
            searchFaq () {
                this.$router.push({
                    name: 'problemSearch',
                    params: {type: null},
                    query: {keywords: this.searchWord}
                })
            },
            insinte () {
               this.history = true
               //获取历史记录
               this.gethistory ()
            },
            blur () {
                this.history = false
            },
            keyword_search (keyfont) {
                this.searchWord = keyfont
                this.$router.push({
                    name: 'problemSearch',
                    params: {type: null},
                    query: {keywords: this.searchWord}
                })
            },
            blurFn () {
                setTimeout(this.blur,500)
            },
            gethistory () {
                //获取历史记录
                const module = 'index.php/history'
                let data = {}
                data.user_id = this.Local.getUserId()
                data.lang = this.$i18n.locale
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                this.$http.get(process.env.BASEURL + module, {params: data})
                    .then(function (response) {
                        console.log(response.data)
                        if(response.data.data.length === null ){
                            this.null_data = true
                        }else{
                            this.null_data = false
                            this.like_list = response.data.data
                        }
                    }.bind(this))
            },


        },
        created () {
            // 获取问题分类
            this.getFaqtType()

        }
    }
</script>
<style lang="scss" scoped>
    @import "../../scss/_services.scss";
</style>



// WEBPACK FOOTER //
// Services.vue?0f364b51